module.exports = __webpack_public_path__ + "static/sk-black-3ea75da89465e71287fc4b050eaf8e28.png";